import React from 'react'

const Magnifier = () => {
  return (
    <svg viewBox="0 0 65 65">
      <path
        fill={'#000'}
        d="M54.4,55c-0.2,0-0.3-0.1-0.4-0.2L37.4,38.2c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0L54.8,54
	c0.2,0.2,0.2,0.6,0,0.8C54.7,54.9,54.6,55,54.4,55z"
      />
      <path
        fill={'#6EC18A'}
        d="M26,42c-8.8,0-16-7.2-16-16c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C42,34.8,34.8,42,26,42z M26,11.2
	c-8.2,0-14.8,6.6-14.8,14.8S17.8,40.8,26,40.8S40.8,34.1,40.8,26S34.1,11.2,26,11.2z"
      />
    </svg>
  )
}

export default Magnifier
